import { Component, TemplateRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-transaction-demande-location',
  standalone: false,
  templateUrl: './transaction-demande-location.component.html',
  styleUrl: './transaction-demande-location.component.scss'
})
export class TransactionDemandeLocationComponent {

  items: any = [];
  user_reference: any;
  paginatedItems = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  isLoading: boolean = false;
  searchTerm: string = "";
  filteredtems: any = [];
  searchDate: string = '';
  dateDebut: string = '';
  dateFin: string = '';
  searchGender: string = '';
  isDisabled: boolean = false;
  
  // Filtre par statut
  selectedStatus: string = '';
  statusOptions: any[] = [
    { label: 'Tous les statuts', value: '' },
    { label: 'En attente', value: 'pending' },
    { label: 'Payé', value: 'paid' },
    { label: 'Échoué', value: 'failed' },
    { label: 'Annulé', value: 'cancelled' }
  ];

  // Filtre par statut de location
  selectedLocationStatus: string = '';
  locationStatusOptions: any[] = [
    { label: 'Tous les statuts', value: '' },
    { label: 'En attente', value: 'pending' },
    { label: 'Approuvé', value: 'approved' },
    { label: 'Rejeté', value: 'rejected' },
    { label: 'Terminé', value: 'completed' }
  ];

  // Filtre par mode de paiement
  selectedPaymentMethod: string = '';
  paymentMethodOptions: any[] = [
    { label: 'Tous les modes', value: '' },
    { label: 'MTN Mobile Money', value: 'mtn' },
    { label: 'Moov Mobile Money', value: 'moov' },
    { label: 'Celtiis', value: 'celtiis' },
    { label: 'Orange Money', value: 'orange' }
  ];
  
  // Propriétés pour le détail
  selectedItem: any = null;
  showDetailModal: boolean = false;
  
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  @ViewChild('detailModal') detailModal!: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private localstorage: LocalStorageService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService,
    private router: RouterModule,
    private FecthDataService: FecthDataService,
    private paramService: ParameterService,
    private authService: AuthService
  ) {
    this.user_reference = this.localstorage.getUsers().data.reference;
    console.log("this.user_reference", this.user_reference);
    this.FecthDataService.actionCreated$.subscribe(() => {
      this.getAllListePaiementLocation();
    });
  }

  ngOnInit() {
    this.getAllListePaiementLocation();
  }

  // Méthode pour ouvrir le modal de détails
  openDetailModal(item: any) {
    this.selectedItem = item;
    this.modalService.open(this.detailModal, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true
    });
  }

  // Méthode pour obtenir le badge de statut de paiement
  getStatusBadge(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'pending': 'bg-warning',
      'paid': 'bg-success',
      'failed': 'bg-danger',
      'cancelled': 'bg-secondary',
      'completed': 'bg-success'
    };
    return statusMap[statut] || 'bg-secondary';
  }

  // Méthode pour obtenir le badge de statut de location
  getLocationStatusBadge(status: string): string {
    const statusMap: {[key: string]: string} = {
      'pending': 'bg-warning',
      'approved': 'bg-success',
      'rejected': 'bg-danger',
      'completed': 'bg-primary'
    };
    return statusMap[status] || 'bg-secondary';
  }

  // Méthode pour obtenir le libellé du statut en français
  getStatusLabel(statut: string): string {
    const statusMap: {[key: string]: string} = {
      'pending': 'En attente',
      'paid': 'Payé',
      'failed': 'Échoué',
      'cancelled': 'Annulé',
      'completed': 'Terminé'
    };
    return statusMap[statut] || statut;
  }

  // Méthode pour obtenir le libellé du statut de location en français
  getLocationStatusLabel(status: string): string {
    const statusMap: {[key: string]: string} = {
      'pending': 'En attente',
      'approved': 'Approuvé',
      'rejected': 'Rejeté',
      'completed': 'Terminé'
    };
    return statusMap[status] || status;
  }

  // Méthode pour obtenir le libellé du mode de paiement
  getPaymentMethodLabel(method: string): string {
    const methodMap: {[key: string]: string} = {
      'mtn': 'MTN Mobile Money',
      'moov': 'Moov Mobile Money',
      'celtiis': 'Celtiis',
      'orange': 'Orange Money'
    };
    return methodMap[method] || method || 'Non spécifié';
  }

  // Méthode pour obtenir une icône du mode de paiement
  getPaymentMethodIcon(method: string): string {
    const iconMap: {[key: string]: string} = {
      'mtn': 'mdi mdi-phone',
      'moov': 'mdi mdi-phone',
      'celtiis': 'mdi mdi-credit-card',
      'orange': 'mdi mdi-phone'
    };
    return iconMap[method] || 'mdi mdi-credit-card';
  }

  // Méthode pour formater la date
  formatDate(date: string): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  // Méthode pour formater la date sans heure
  formatDateShort(date: string): string {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  getAllListePaiementLocation() {
    this.isLoading = true;
    this.authService.getAllListePaiementLocation(this.user_reference).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.items = response.data;
        this.filteredtems = this.items;
        this.totalRecords = this.items.length;
        this.applyFilters();
        console.log("la reponse du webservice", this.items);
      },
      (error) => {
        console.log("une erreur est survenue", error);
        this.isLoading = false;
      }
    )
  }

  resetFilters() {
    this.searchTerm = '';
    this.selectedStatus = '';
    this.selectedLocationStatus = '';
    this.selectedPaymentMethod = '';
    this.dateDebut = '';
    this.dateFin = '';
    this.applyFilters();
  }

  // Méthode pour appliquer tous les filtres
  applyFilters() {
    let filtered = this.items;

    // Filtre par statut de paiement
    if (this.selectedStatus) {
      filtered = filtered.filter(item => item.statut === this.selectedStatus);
    }

    // Filtre par statut de location
    if (this.selectedLocationStatus) {
      filtered = filtered.filter(item => item.location?.status === this.selectedLocationStatus);
    }

    // Filtre par mode de paiement
    if (this.selectedPaymentMethod) {
      filtered = filtered.filter(item => item.mode_paiement === this.selectedPaymentMethod);
    }

    // Filtre par date
    if (this.dateDebut) {
      const startDate = new Date(this.dateDebut);
      startDate.setHours(0, 0, 0, 0);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate >= startDate;
      });
    }

    if (this.dateFin) {
      const endDate = new Date(this.dateFin);
      endDate.setHours(23, 59, 59, 999);
      filtered = filtered.filter(item => {
        const itemDate = new Date(item.created_at);
        return itemDate <= endDate;
      });
    }

    // Filtre par recherche
    if (this.searchTerm && this.searchTerm.trim() !== '') {
      const search = this.searchTerm.toLowerCase().trim();
      filtered = filtered.filter(item =>
        (item?.reference && item.reference.toLowerCase().includes(search)) ||
        (item?.transaction_id && item.transaction_id.toLowerCase().includes(search)) ||
        (item?.membre?.nom && item.membre.nom.toLowerCase().includes(search)) ||
        (item?.membre?.prenom && item.membre.prenom?.toLowerCase().includes(search)) ||
        (item?.telephone && item.telephone.toLowerCase().includes(search)) ||
        (item?.statut && item.statut.toLowerCase().includes(search)) ||
        (item?.location?.machine?.nom && item.location.machine.nom.toLowerCase().includes(search)) ||
        (item?.montant && item.montant.toString().includes(search))
      );
    }

    this.filteredtems = filtered;
    this.totalRecords = this.filteredtems.length;
    this.first = 0;
    this.updatePaginated();
  }

  // Méthode appelée lors du changement de filtre
  onStatusChange() {
    this.applyFilters();
  }

  onLocationStatusChange() {
    this.applyFilters();
  }

  onPaymentMethodChange() {
    this.applyFilters();
  }

  // Méthode appelée lors de la recherche
  filterBySearchTerm() {
    this.applyFilters();
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePaginated();
  }

  updatePaginated() {
    const start = this.first;
    const end = start + this.rows;
    this.paginatedItems = this.filteredtems.slice(start, end);
  }

  // Méthode pour compter les transactions par statut
  getStatusCount(status: string): number {
    if (!this.items) return 0;
    if (!status) return this.items.length;
    return this.items.filter(item => item.statut === status).length;
  }

  getLocationStatusCount(status: string): number {
    if (!this.items) return 0;
    if (!status) return this.items.length;
    return this.items.filter(item => item.location?.status === status).length;
  }

  // Méthode pour calculer le nombre de jours de location
  getLocationDays(item: any): number {
    if (!item?.location?.date_debut || !item?.location?.date_fin) return 0;
    const start = new Date(item.location.date_debut);
    const end = new Date(item.location.date_fin);
    const diffTime = Math.abs(end.getTime() - start.getTime());
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }
}